<template>
    <v-toolbar class="light-blue lighten-2 white--text">
        <v-toolbar-title>
            <router-link v-if="isCurrentUserAdmin" to="/">
                <v-icon class="white--text" medium>home</v-icon>
            </router-link>
            {{ title }}
        </v-toolbar-title>

        <v-spacer/>

        <router-link v-if="isCurrentUserAdmin" :to="{ name: 'document-search'}" class="mx-3">
            <v-icon class="white--text" medium>search</v-icon>
        </router-link>

        <LogoutButton :key="$route.fullPath"/>
    </v-toolbar>
</template>

<script>
    import {mapGetters} from "vuex";
    import LogoutButton from "../components/security/LogoutButton";

    export default {
        name: "Header",
        components: {LogoutButton},
        computed: {
            ...mapGetters(["currentDirectoryName", "isCurrentUserAdmin"]),
            title: function () {
                if (this.$router.currentRoute.name === 'login') {
                    return 'CLLP';
                } else if (this.$router.currentRoute.name === 'document-search') {
                    return "Recherche de documents";
                } else if (this.currentDirectoryName) {
                    return this.currentDirectoryName;
                } else {
                    return 'CLLP';
                }
            }
        }
    };
</script>

<style scoped lang="scss"></style>
